import React from "react"
import { styled } from "@mui/material/styles"
import { Popover, Typography, Button } from "@mui/material"

const PopoverContent = styled("div")`
  padding: 16px;
  max-width: 200px;
`

const PopoverActions = styled("div")`
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
`

export default class ConfirmationPopover extends React.Component {
  render() {
    const { anchorEl, open, onClose, onConfirm, message } = this.props

    return (
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <PopoverContent>
          <Typography variant="body1">{message}</Typography>
          <PopoverActions>
            <Button
              onClick={onClose}
              size="small"
              style={{ marginRight: "8px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={onConfirm}
              size="small"
              variant="contained"
              color="primary"
            >
              Delete
            </Button>
          </PopoverActions>
        </PopoverContent>
      </Popover>
    )
  }
}
